import { Helmet } from 'react-helmet-async';
import ServicePage from './ServicePage';
import { useService } from '../hooks/usePublicApi';
import { serviceCategories } from '../data/services';

const staticData = serviceCategories.find((s) => s.id === 'umbau');

export default function Umbau() {
  const { service } = useService('umbau');
  const data = service || staticData;

  return (
    <>
      <Helmet>
        <title>Umbau & Modernisierung | Süd Ausbau GmbH</title>
        <meta name="description" content="Umbau und Modernisierung bestehender Räumlichkeiten in München. Neue Raumkonzepte und optimierte Grundrisse — Süd Ausbau GmbH." />
        <link rel="canonical" href="https://sued-ausbau.de/umbau" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sued-ausbau.de/umbau" />
        <meta property="og:title" content="Umbau & Modernisierung | Süd Ausbau GmbH" />
        <meta property="og:description" content="Umbau und Modernisierung bestehender Räumlichkeiten in München. Neue Raumkonzepte und optimierte Grundrisse — Süd Ausbau GmbH." />
        <meta property="og:image" content="https://sued-ausbau.de/og-preview.png" />
      </Helmet>
      <ServicePage data={data} />
    </>
  );
}
